// extracted by mini-css-extract-plugin
export default {"tableHeader":"styles_tableHeader__ornia","sortable":"styles_sortable__m5+Sa","rightAligned":"styles_rightAligned__ECkHX","sortIcon":"styles_sortIcon__PG-VZ"};